import React from "react";
import {
  FaPenFancy,
  FaLaptop,
  FaTasks,
  FaTachometerAlt,
  FaRecycle,
  FaHeadset,
} from "react-icons/fa";
import "../ERPServices.css";

const services = [
  {
    icon: <FaPenFancy />,
    title: "Project Creation",
    description:
      "Comprehensive project planning and blueprint design aligned with your ERP goals.",
  },
  {
      icon: <FaLaptop />,   
    title: "Software Development",
    description:
      "Custom ERP development tailored to your industry and business requirements.",
  },
  {
    icon: <FaTasks />,
    title: "Project Management",
    description:
      "Structured project execution ensuring timely and cost-effective delivery.",
  },
  {
    icon: <FaTachometerAlt />,
    title: "Project Implementation",
    description:
      "Seamless ERP implementation with minimal business disruption.",
  },
  {
    icon: <FaRecycle />,
    title: "Software Updates",
    description:
      "Regular system upgrades and performance optimization for long-term success.",
  },
  {
    icon: <FaHeadset />,
    title: "24/7 Support",
    description:
      "Dedicated support team to ensure smooth ERP operations anytime.",
  },
];

const ERPServices = () => {
  return (
    <div className="we-offer-area text-center bg-light py-5">
      <div className="container">
        <div className="row mb-5">
          <div className="col-12">
            <h2 className="fw-bold">
              ERP <span className="text-primary">Services</span>
            </h2>
            <h5 className="text-muted">
              Comprehensive ERP solutions tailored for your business
            </h5>
          </div>
        </div>

        <div className="row">
          {services.map((service, index) => (
            <div key={index} className="col-12 col-sm-6 col-md-4 mb-4">
              <div className="p-4 shadow-sm bg-white h-100 rounded">
                <div className="mb-3 text-primary fs-2">
                  {service.icon}
                </div>
                <h4 className="fw-semibold">{service.title}</h4>
                <p className="text-muted">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ERPServices;